// export const canvasWidth = 1920;
// export const canvasHeight = 920;
export const canvasWidth = window.innerWidth;
export const canvasHeight = window.innerHeight - 80;

export {};
